export default __webpack_public_path__ + "static/media/manager.1c698bed.svg";